import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=6c7d774c&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=6c7d774c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d774c",
  null
  
)

export default component.exports